var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"path-1_1_","fill":"#414042","d":"M8.999,7.001l2.999-2.999c0.552-0.552,1.447-0.552,1.998,0c0.553,0.552,0.553,1.447,0,1.999\r\n\tL10.998,9l2.996,2.996c0.552,0.553,0.552,1.446,0,1.998s-1.445,0.552-1.998,0L9,10.998l-2.999,2.998\r\n\tc-0.552,0.553-1.447,0.553-1.999,0c-0.552-0.552-0.552-1.446,0-1.998l2.999-2.999L4.006,6.003c-0.552-0.552-0.552-1.446,0-1.998\r\n\ts1.446-0.552,1.998,0L8.999,7.001z"}));
}

CloseIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"18px","height":"18px","viewBox":"0 0 18 18","enableBackground":"new 0 0 18 18","xmlSpace":"preserve"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
